/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type NetworkIngressDeleteImpact = {
  mcpServersDual: number;
  mcpServersPrivateOnly: number;
  metaMcpServersDual: number;
  metaMcpServersPrivateOnly: number;
};

/** @internal */
export const NetworkIngressDeleteImpact$inboundSchema: z.ZodMiniType<
  NetworkIngressDeleteImpact,
  unknown
> = z.pipe(
  z.object({
    mcp_servers_dual: z.int(),
    mcp_servers_private_only: z.int(),
    meta_mcp_servers_dual: z.int(),
    meta_mcp_servers_private_only: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_servers_dual": "mcpServersDual",
      "mcp_servers_private_only": "mcpServersPrivateOnly",
      "meta_mcp_servers_dual": "metaMcpServersDual",
      "meta_mcp_servers_private_only": "metaMcpServersPrivateOnly",
    });
  }),
);

export function networkIngressDeleteImpactFromJSON(
  jsonString: string,
): SafeParseResult<NetworkIngressDeleteImpact, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => NetworkIngressDeleteImpact$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'NetworkIngressDeleteImpact' from JSON`,
  );
}
